<template>
  <div id="app" :lang="this.$i18n.locale">
    <router-view></router-view>
    <alert-modal />
    <confirm-modal />
    <data-modal />
  </div>
</template>

<script>
import AlertModal from '@/components/modules/common/AlertModal';
import ConfirmModal from '@/components/modules/common/ConfirmModal';
import DataModal from '@/components/modules/common/DataModal';
import { isMobile, isMobileOS, addClass } from '@/utils';
import Cookies from 'js-cookie';

export default {
  name: 'app',
  components: {
    AlertModal,
    ConfirmModal,
    DataModal,
  },
  watch: {
    '$i18n.locale': function () {
      document.documentElement.setAttribute('lang', this.$i18n.locale);
    },
  },
  created() {
    document.documentElement.setAttribute('lang', this.$i18n.locale);
    Cookies.set('isMobile', isMobile);
    if (isMobileOS) {
      addClass(document.body, isMobileOS);
    }
  },
};
</script>

<style lang="scss">
@import 'assets/scss/style';
</style>
